module.exports = "https://cdn.realtymogul.com/static/media/bell_black.0254af6f.svg";